import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-5xl font-semibold text-center text-gray-800 mb-6">Privacy Policy</h1>
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-3xl font-semibold text-gray-800 mb-4">Introduction</h2>
          <p className="text-gray-700">
            This Privacy Policy explains how we collect, use, and protect your information when you use Taxica services.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">1. Information We Collect</h2>
          <p className="text-gray-700">
            We collect personal information like your name, email address, phone number, and payment details when you book a ride.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">2. How We Use Your Information</h2>
          <p className="text-gray-700">
            Your information is used to provide the taxi services, process payments, and improve the user experience.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">3. Data Sharing</h2>
          <p className="text-gray-700">
            We do not share your personal data with third parties unless required by law or necessary for the provision of services.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">4. Data Security</h2>
          <p className="text-gray-700">
            We implement industry-standard security measures to protect your data from unauthorized access.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">5. Cookies</h2>
          <p className="text-gray-700">
            Our website uses cookies to enhance user experience. You can control cookie settings in your browser.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">6. Your Rights</h2>
          <p className="text-gray-700">
            You have the right to access, update, or delete your personal data by contacting us at any time.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-4">7. Changes to Privacy Policy</h2>
          <p className="text-gray-700">
            We may update our Privacy Policy from time to time. Any changes will be posted on this page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
